module.exports = __webpack_public_path__ + "img/ph.54385fa5.png";